import React, { useState, useRef } from "react";

// ===================================================================
// The Crowd v2 — Selecteur de personnes (annuaire)
//
// Champ de recherche avec suggestions, et personnes retenues affichees
// en pastilles retirables. Sans doublon (comparaison sur l'adresse).
// Aucun appel reseau : la page fournit `rechercher(texte)`, qui renvoie
// une promesse de [{ displayName, email }].
//
// Props : id, selection, onChange(selection), rechercher, placeholder
// ===================================================================

function SelecteurPersonnes({ id, selection, onChange, rechercher, placeholder = "Rechercher par nom ou adresse…" }) {
  const [texte, setTexte] = useState("");
  const [resultats, setResultats] = useState([]);
  const [enCours, setEnCours] = useState(false);
  const minuterie = useRef(null);

  const saisir = (e) => {
    const v = e.target.value;
    setTexte(v);
    clearTimeout(minuterie.current);
    minuterie.current = setTimeout(async () => {
      setEnCours(true);
      const res = await rechercher(v);
      setResultats(res);
      setEnCours(false);
    }, 350);
  };

  const choisir = (personne) => {
    const deja = selection.some((s) => (s.email || "").toLowerCase() === (personne.email || "").toLowerCase());
    if (!deja) onChange([...selection, personne]);
    setTexte("");
    setResultats([]);
  };

  const retirer = (email) => onChange(selection.filter((s) => s.email !== email));

  return (
    <div className="v2-personnes">
      {selection.length > 0 && (
        <ul className="v2-personnes-choix">
          {selection.map((p) => (
            <li key={p.email} className="v2-pastille">
              <span>{p.displayName}</span>
              <button type="button" className="v2-pastille-retirer" onClick={() => retirer(p.email)} aria-label={`Retirer ${p.displayName}`}>
                ×
              </button>
            </li>
          ))}
        </ul>
      )}

      <div className="v2-champ v2-personnes-saisie">
        <input
          id={id}
          value={texte}
          onChange={saisir}
          placeholder={placeholder}
          autoComplete="off"
          role="combobox"
          aria-expanded={resultats.length > 0}
          aria-autocomplete="list"
        />
        {enCours && <span className="v2-champ-aide">Recherche…</span>}

        {resultats.length > 0 && (
          <ul className="v2-personnes-suggestions" role="listbox">
            {resultats.map((u) => (
              <li key={u.email} role="option" aria-selected="false">
                <button type="button" className="v2-personnes-suggestion" onClick={() => choisir(u)}>
                  <span className="v2-personnes-nom">{u.displayName}</span>
                  <span className="v2-personnes-adresse">{u.email}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default SelecteurPersonnes;
